import { createRoot } from 'react-dom/client';
import { App } from '../portal/public_home/App';
import { transformKeysToCamel } from '../portal/utils/caseTransforms';

const rootElement = document.getElementById("portal-root");
if (!rootElement) {
  throw new Error("Root element not found");
}

// Extract page slug, form slug, preview mode, and team data from data attributes
const pageSlug = rootElement.dataset.pageSlug || null;
const formSlug = rootElement.dataset.formSlug || null;
const previewMode = rootElement.dataset.previewMode === 'true';
const rawTeamData = rootElement.dataset.team ? JSON.parse(rootElement.dataset.team) : null;
let teamData = rawTeamData ? transformKeysToCamel(rawTeamData) : null;
console.log('Parsed team data:', teamData);

// Parse the style field if it's a string (JSON)
if (teamData && teamData.style && typeof teamData.style === 'string') {
  try {
    teamData.style = JSON.parse(teamData.style);
    // Transform style keys to camelCase as well
    teamData.style = transformKeysToCamel(teamData.style);
  } catch (e) {
    console.error('Failed to parse team style:', e);
    teamData.style = null;
  }
}

// If we have a formSlug, we should navigate to the form route
if (formSlug && window.location.pathname !== `/forms/${formSlug}`) {
  window.history.replaceState({}, '', `/forms/${formSlug}`);
}

const root = createRoot(rootElement);
root.render(<App teamData={teamData} pageSlug={pageSlug} formSlug={formSlug} previewMode={previewMode} />);